var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"kanbanViewerContainer",staticClass:"kanban-container"},[(_vm.kanbanSettings)?_c('iframe',{staticClass:"kanban-iframe",attrs:{"src":_vm.kanbanUrl}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }